module.exports = __webpack_public_path__ + "img/logo-global.f3baa9e8.jpg";